import { GetterTree } from 'vuex'
import { ISidebarState } from './types'

const getters: GetterTree<ISidebarState, any> = {
  isSidebarOpen(state): boolean {
    return state.isSidebarOpen
  },
  isSettingsPanelOpen(state): boolean {
    return state.isSettingsPanelOpen
  },
  isWhatsNewPanelOpen(state): boolean {
    return state.isWhatsNewPanelOpen
  },
  isHelpPanelOpen(state): boolean {
    if (state.enableHelpPanel === false) {
      return false
    } else {
      return state.isHelpPanelOpen
    }
  },
}

export default getters

